// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.LapMarker_marker__Feeqt {
    width: 20px;
    height: 20px;
    line-height: 20px;
    color: var(--color-101);
    /* Using colors and not the color vars since this isn't working for some reason. */
    box-shadow: inset 0 0 0 1px rgba(110,133,148,.8), 0 1px 0 0 rgba(0, 0, 0, 0.1);
    border-width: 0px;
    background: white;
    border-style: solid;
    display: table-cell;
    text-align: center;
    vertical-align: middle;
    border-radius: 50%;
    font-size: 10px;
    font-weight: 700;
} 
`, "",{"version":3,"sources":["webpack://./node_modules/ui-connect/Maps/LapMarker.module.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,uBAAuB;IACvB,kFAAkF;IAClF,8EAA8E;IAC9E,iBAAiB;IACjB,iBAAiB;IACjB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;AACpB","sourcesContent":[".marker {\n    width: 20px;\n    height: 20px;\n    line-height: 20px;\n    color: var(--color-101);\n    /* Using colors and not the color vars since this isn't working for some reason. */\n    box-shadow: inset 0 0 0 1px rgba(110,133,148,.8), 0 1px 0 0 rgba(0, 0, 0, 0.1);\n    border-width: 0px;\n    background: white;\n    border-style: solid;\n    display: table-cell;\n    text-align: center;\n    vertical-align: middle;\n    border-radius: 50%;\n    font-size: 10px;\n    font-weight: 700;\n} \n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"marker": `LapMarker_marker__Feeqt`
};
export default ___CSS_LOADER_EXPORT___;
